<template>
  <div>
    <BaseHeader title="ダッシュボード" />
    <div class="dashboard-block">
      <h2 class="title">
        <img class="title-icon"
            src="@/assets/img/dash-icon1.png"
            alt="CCS">
        カスタマーアラート
      </h2>
      <table class="table1">
        <tr><th>カテゴリ</th><th>メッセージ</th><th>日付</th></tr>
        <tr>
          <td><span class="cat1">引当</span></td>
          <td>未引当状態が2ヶ月を超えています。<a href="">（D595-180928-00493）</a></td>
          <td>2018/10/24</td>
        </tr>
        <tr>
          <td><span class="cat2">出荷</span></td>
          <td>出荷不可(欠品)が報告されました。<a href="">（D298-181021-02939）</a></td>
          <td>2018/10/22</td>
        </tr>
        <tr>
          <td><span class="cat3">決済</span></td>
          <td>決済処理に失敗しました。<a href="">（D596-181020-00882）</a></td>
          <td>2018/10/22</td>
        </tr>
        <tr>
          <td><span class="cat3">決済</span></td>
          <td>決済処理に失敗しました<a href="">（D596-181017-19031）</a></td>
          <td>2018/10/20</td>
        </tr>
      </table>
    </div>

    <div class="dashboard-block">
      <h2 class="title">
        <img class="title-icon"
            src="@/assets/img/dash-icon2.png"
            alt="CCS">
        インフォメーション
      </h2>
      <table class="table1">
        <tr><th>カテゴリ</th><th>メッセージ</th><th>日付</th></tr>
        <tr>
          <td><span class="cat4">システム</span></td>
          <td>バージョンアップしました。<a href="">（新機能はこちら！）</a></td>
          <td>2018/10/20</td>
        </tr>
        <tr>
          <td><span class="cat4">システム</span></td>
          <td>2018/11/4(日) 2:00～4:00 メンテナンスによりシステムが利用できません<a href="">（詳細）</a></td>
          <td>2018/10/21</td>
        </tr>
      </table>
    </div>

    <div class="dashboard-block-title">
      <h2 class="title">
        <img
            class="title-icon"
            src="@/assets/img/dash-icon3.png"
            alt="CCS">
        注文サマリー
      </h2>
      <div class="dates">
        <el-select
            v-model="selectedGroup1"
            placeholder="サイト"
            @change="onGroupChanged($event)">
          <el-option
              v-for="option in siteGroups"
              :key="option.code"
              :label="option.name"
              :value="option.code" />
        </el-select>
        <el-select
            v-model="selectedGroup2"
            placeholder="ブランド"
            @change="onGroupChanged($event)">
          <el-option
              v-for="option in brandGroups"
              :key="option.code"
              :label="option.name"
              :value="option.code" />
        </el-select>
        <el-select
            v-model="selectedGroup3"
            placeholder="日別"
            @change="onGroupChanged($event)">
          <el-option
              v-for="option in orderGroups"
              :key="option.code"
              :label="option.name"
              :value="option.code" />
        </el-select>
        <el-date-picker
            v-model="selectedGroup4"
            type="date"
            placeholder="2018/10/19" />
        <span class="date-sep">〜</span>
        <el-date-picker
            v-model="selectedGroup5"
            type="date"
            placeholder="2018/10/19" />
      </div>
    </div>

    <div class="dashboard-cols">
      <div class="col">
        <div class="dashboard-block">
          <div class="dashboard-block-inner">
            <img
                src="@/assets/img/dummy1.png"
                alt="CCS">
          </div>
        </div>
      </div>
      <div class="col">
        <div class="dashboard-block">
          <div class="dashboard-block-inner">
            <img
                src="@/assets/img/dummy1.png"
                alt="CCS">
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-block">
      <table class="order-table">
        <tr><th colspan="2">&nbsp;</th><th colspan="6">当年</th><th colspan="6">前年</th></tr>
        <tr><th colspan="2">&nbsp;</th><th>注文金額</th><th>注文点数</th><th>注文数</th><th>セット率<br>(UPT)</th><th>商品単価<br>(AUR)</th><th>注文単価<br>(AT)</th><th>注文金額</th><th>注文点数</th><th>注文数</th><th>セット率<br>(UPT)</th><th>商品単価<br>(AUR)</th><th>注文単価<br>(AT)</th></tr>
        <tr>
          <td>
            2018/10/19
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide=!isHide">
            <img
                :class="{isHide:isHide}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide=!isHide">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide}">
          <td>ブランドC</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide}">
          <td>ブランドD</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide}">
          <td>ブランドE</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>

        <tr>
          <td>
            2018/10/21
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide2}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide2=!isHide2">
            <img
                :class="{isHide:isHide2}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide2=!isHide2">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide2}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide2}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr>
          <td>
            2018/10/22
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide3}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide3=!isHide3">
            <img
                :class="{isHide:isHide3}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide3=!isHide3">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide3}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide3}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr>
          <td>
            2018/10/23
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide4}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide4=!isHide4">
            <img
                :class="{isHide:isHide4}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide4=!isHide4">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide4}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide4}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr>
          <td>
            2018/10/24
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide5}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide5=!isHide5">
            <img
                :class="{isHide:isHide5}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide5=!isHide5">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide5}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide5}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr>
          <td>
            2018/10/25
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide6}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide6=!isHide6">
            <img
                :class="{isHide:isHide6}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide6=!isHide6">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide6}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide6}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr>
          <td>
            2018/10/26
            <img
                class="btn1"
                src="@/assets/img/dash-btn1.png"
                alt="CCS">
          </td>
          <td>
            <img
                :class="{isHide:isHide7}"
                class="btn2 open"
                src="@/assets/img/dash-btn3.png"
                alt="CCS"
                @click="isHide7=!isHide7">
            <img
                :class="{isHide:isHide7}"
                class="btn2 close"
                src="@/assets/img/dash-btn2.png"
                alt="CCS"
                @click="isHide7=!isHide7">
          </td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide7}">
          <td>ブランドA</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
        <tr :class="{isHide:isHide7}">
          <td>ブランドB</td><td>&nbsp;</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
          <td>0,000,000</td><td>000</td><td>000</td><td>0.00</td><td>0,000</td><td>00,000</td>
        </tr>
      </table>
    </div>

    <div class="dashboard-cols">
      <div class="col">
        <div class="dashboard-block">
          <div class="dashboard-block-inner">
            <img
                src="@/assets/img/dummy2.png"
                alt="CCS">
          </div>
        </div>
      </div>
      <div class="col">
        <div class="dashboard-block">
          <div class="dashboard-block-inner">
            <img
                src="@/assets/img/dummy3.png"
                alt="CCS">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseHeader from '@/components/molecules/BaseHeader'

export default {
  name: 'DashBoard',
  components: {
    BaseHeader
  },
  data () {
    return {
      siteGroups: [],
      brandGroups: [],
      orderGroups: [],
      selectedGroup1: null,
      selectedGroup2: null,
      selectedGroup3: null,
      selectedGroup4: '',
      selectedGroup5: '',
      isHide: true,
      isHide2: true,
      isHide3: true,
      isHide4: true,
      isHide5: true,
      isHide6: true,
      isHide7: true
    }
  },
  computed: {
    ...mapState({
    })
  },
  watch: {
  },
  created () {
    this.siteGroups = this.getSiteGroups()
    this.brandGroups = this.getBrandGroups()
    this.orderGroups = this.getOrderGroups()
  },
  beforeUpdate () {
  },
  mounted () {
  },
  methods: {
    getSiteGroups () {
      return [
        { code: 1, name: 'サイトA' },
        { code: 2, name: 'サイトB' },
        { code: 3, name: 'サイトC' }
      ]
    },
    getBrandGroups () {
      return [
        { code: 1, name: 'ブランドA' },
        { code: 2, name: 'ブランドB' },
        { code: 3, name: 'ブランドC' }
      ]
    },
    getOrderGroups () {
      return [
        { code: 1, name: '日別A' },
        { code: 2, name: '日別B' },
        { code: 3, name: '日別C' }
      ]
    },
    onGroupChanged (event) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DashBoardTopDemo.vue